export const KEY_RESUME_OF_DAY_PANEL = 'panels-resume-of-day'

export const KEY_HEAT_MAP_BY_BUSINESS = 'panels-heatmap-by-business'

export const KEY_RADAR_BIG_NUMBERS = 'panels-radar-big-numbers'

export const KEY_SUMMARY_BY_VISION = 'panels-summary-by-vision'

export const KEY_FUNNEL_CONVERSION = 'panels-funnel-conversion'

export const KEY_RESUME_APNEF = 'panels-resume-apnef'

export const KEY_PROPOSAL_RESUME_APNEF = 'panels-proposal-resume-apnef'

export const KEY_ANCHIEVEMENT_RV_PANEL = 'panels-anchievement-rv'

export const KEY_PRODUCTION_FINANCIAL = 'panels-production-financial'

export const KEY_AFFILIATE_DETAILS = 'panels-affiliate-details'

export const KEY_PANEL_STAFF = 'panels-staff'

export const KEY_MESH_PRODUCTION = 'panels-mesh-production'

export const KEY_GR_PRODUCTION = 'panels-gr-production'

export const KEY_BAII_PER_WALLET = 'panels-baii-per-wallet'

export const KEY_CONTRACTS_SIGNED = 'panels-big-views-contracts-signed'

export const KEY_FPD10_PRODUCTION = 'panels-fpd10-production'

export const KEY_SPREAD = 'panels-spread'

export const KEY_LEADERS = 'panels-leaders'

export const KEY_MARKET_MOM = 'panels-market-mom'

export const KEY_SANTANDER_MOM = 'panels-santanter-mom'

export const KEY_CONSOLIDATED = 'panels-consolidated'

export const KEY_BIG_QUESTIONS = 'panels-big-questions'

export const KEY_BIG_QUESTIONS_CHART = 'panels-big-questions-chart'

export const KEY_MIX_BY_SEGMENT = 'panels-mix-by-segment'

export const KEY_MARKET_POTENTIAL = 'panels-market-potential'

export const KEY_MARKET_SHARE_MONTH = 'panels-market-share-month'

export const KEY_MARKET_ELECTRIC_CARS = 'panels-market-share-electric-cars'

export const KEY_BIG_NUMBERS_PAGE = 'panels-big-numbers-page'

export const KEY_BIG_NUMBERS_SECTION = 'panels-big-numbers-section'

export const KEY_BIG_NUMBERS_BY_TYPE = 'panels-big-numbers-by-type'

export const KEY_BIG_VIEWS = 'panels-big-views'

export const KEY_BIG_VIEWS_BAR_CARD = 'panels-big-views-bar-card'

export const KEY_BIG_VIEWS_PIE_CARD = 'panels-big-views-pie-card'

export const KEY_CONVERSIONS = 'panels-conversions'

export const KEY_BRIDGE_MOM = 'panels-bridge-mom'

export const KEY_BANKING_MARKET = 'panels-banking-market'

export const KEY_MARKET_MIX_SEGMENT_QUANTITY =
  'panels-market-mix-segment-quantity'

export const KEY_MARKET_MIX_SEGMENT_VOLUME = 'panels-market-mix-segment-volume'

export const KEY_MARKET_MIX_SEGMENT_BANK = 'panels-market-mix-segment-bank'

export const KEY_MARKET_MIX_SEGMENT_BANK_TERM =
  'panels-market-mix-segment-bank-term'

export const KEY_RADAR_CHARTS = 'panels-radar-charts'

export const KEY_RV_CHARTS = 'panels-rv-charts'

export const KEY_HOUR_BY_HOUR = 'panels-hour-by-hour'

export const KEY_RV_CHARTS_CARDS = 'panels-rv-charts-cards'

export const KEY_MY_PANELS = 'my-panels'

export const KEY_MARKET_SHARE_CHARTS = 'panels-market-share-charts'

export const KEY_PEOPLE_HIERARCHY = 'panels-people-hierarchy'

export const KEY_PRODUCTION_CHART = 'panels-production-chart'

export const KEY_WALLET = 'panels-wallet'

export const KEY_OPPORTUNITIES = 'panels-opportunities'

export const KEY_OPPORTUNITIES_LIST = 'panels-opportunities-list'

export const KEY_OPPORTUNITIES_NUMBERS = 'panels-opportunities-numbers'

export const KEY_OPPORTUNITIES_NAVIGATION = 'affiliate-navigation'

export const KEY_LOYAL_STORES = 'loyal-stores'

export const KEY_LOYAL_STORES_BY_NETWORK = 'loyal-stores-by-network'

export const KEY_FIDELITY_KPIS = 'fidelity-kpis'

export const KEY_FIDELITY_KPIS_BY_NETWORK = 'fidelity-kpis-by-network'

export const KEY_TAB_SUMMARY_META = 'tab-summary-meta'

export const KEY_TAB_SUMMARY_STORE = 'tab-summary-store'

export const KEY_FIDELITY = 'fidelity'

export const KEY_PROPOSTAS_PAGAS = 'propostas-pagas'

export const KEY_PROPOSTAS_PAGAS_METRICS = 'propostas-pagas-metrics'

export const KEY_PROPOSTAS_APROVADAS_NAO_EFETIVADAS = 'propostas-aprovadas-nao-efetivadas'

export const KEY_PROPOSTAS_APROVADAS_NAO_EFETIVADAS_METRICS = 'propostas-aprovadas-nao-efetivadas-metrics'

export const KEY_PROPOSALS_PAGE = 'proposals-page'
